import { ZendeskModel } from './shared/features/zendesk/zendesk.model';
export class ZendeskConfig extends ZendeskModel {
    constructor() {
        super(...arguments);
        this.accountUrl = 'biodigital.zendesk.com';
    }
    beforePageLoad(zE) {
        zE.setLocale('en');
        zE.hide();
    }
}
export class ZendeskConfigModule {
}
